import { useEffect, useRef } from 'react'

export default function DmarcPage() {
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    // Adjust iframe height to fill viewport
    const resize = () => {
      if (iframeRef.current) {
        iframeRef.current.style.height = (window.innerHeight - 64) + 'px'
      }
    }
    resize()
    window.addEventListener('resize', resize)
    return () => window.removeEventListener('resize', resize)
  }, [])

  return (
    <iframe
      ref={iframeRef}
      src='/analytics/dmarc/index.html'
      title='DMARC Analytics Dashboard'
      className='w-full border-none'
      style={{ height: 'calc(100vh - 64px)', marginTop: '-24px', marginLeft: '-24px', marginRight: '-24px', width: 'calc(100% + 48px)' }}
    />
  )
}
